module.exports = __webpack_public_path__ + "img/subtitle.83821d68.png";